import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import * as url from "../../helpers/url_helper";
import { toast } from "react-toastify";

const CategoryList = (props) => {
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Event", link: "#" },
    { title: "Manage Category", link: "#" },
  ];
  useEffect(() => {
    getCategoryList();
    props.setBreadcrumbItems("Manage Category", breadcrumbItems);
  }, []);

  const [isLoading, setLoading] = useState(false);
  const [eventCategoryList, setEventCategoryList] = useState([]);
  const { id } = useParams();

  const handleDeleteClick = async (e, eventItem) => {
    e.preventDefault();
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this category?",
    );
    if (!isConfirmed) return;

    try {
      const response = await fetch(
        `${url.VUF_APP_API}eventcategory/${id}/deleteCategory/${eventItem}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (data.status) {
        setEventCategoryList((prevEvents) =>
          prevEvents.filter((event) => event._id !== eventItem),
        );
        toast.success("Event Removed Successfully.");
      } else {
        const errorMessage =
          data.error || "Something went wrong, please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error("Network error. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };
  const formattedEventList = eventCategoryList.map((eventCategory) => ({
    ...eventCategory,
    status: eventCategory.status ? "Active" : "InActive",
    Action: [
      <Link
        to={`/Event/${eventCategory.eventId}/EventCategory/viewCategoryDetails/${eventCategory._id}`}
        className="btn btn-info btn-sm m-1 "
      >
        <span className="menu-text" style={{ color: "white" }}>
          <span
            className=" menu-icon fas fa fa-eye"
            style={{ color: "white" }}
          ></span>
        </span>
      </Link>,
      <Link
        to={`/Event/${eventCategory.eventId}/EventCategory/edit-category/${eventCategory._id}`}
        className="btn btn-secondary btn-sm m-1"
        data-toggle="tooltip"
        title="Edit Event"
      >
        <span className="menu-text" style={{ color: "white" }}>
          <span
            className=" menu-icon fas fa fa-pen"
            style={{ color: "white" }}
          ></span>
        </span>
      </Link>,
      <button
        type="button"
        className="btn btn-danger btn-sm  m-1"
        onClick={(e) => {
          handleDeleteClick(e, eventCategory._id);
        }}
      >
        <span
          className=" menu-icon fas fa fa-trash"
          style={{ color: "white" }}
        ></span>
      </button>,
    ],
  }));
  const tableData = {
    columns: [
      {
        label: "Category Name",
        field: "name",
        sort: "asc",
        width: 23,
      },
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 5,
      },
      {
        label: "Price",
        field: "price",
        sort: "asc",
        width: 20,
      },
      {
        label: "Action",
        field: "Action",
        sort: "asc",
        width: 20,
      },
    ],
    rows: formattedEventList,
  };
  function getCategoryList() {
    setLoading(true);
    // let urlPath = `eventcategory/${id}/listCategory/`;
    let urlPath = `eventcategory/${id}/listCategory/`;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          setEventCategoryList(responseData.data);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="row align-items-center mb-1">
                  <div className="col-md-6 col-sm-12">
                    <CardTitle className="h4 mb-0">Manage Category</CardTitle>
                  </div>

                  <div className="col-md-6 col-sm-12 text-md-end text-sm-start mt-2 mt-md-0">
                    <Link
                      to={`/Event/${id}/EventCategory/add-category`}
                      className="btn btn-outline-primary me-3"
                    >
                      <i className="fa fa-plus me-1"></i>
                      <span className="menu-text">Add Category</span>
                    </Link>
                    <Link
                      to={`/EventList`}
                      className="btn btn-outline-secondary"
                    >
                      <i className="fa fa-arrow-left me-1"></i>
                      <span className="menu-text">Back Event List</span>
                    </Link>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <br />
                <div class="row">
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CategoryList);
